import React from 'react';

const GoogleSignInButton = () => {
    const handleGoogleSignIn = () => {
        if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
            console.error('Google Client ID not configured');
            return;
        }

        // Use environment variable for redirect URI
        const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
        
        if (!redirectUri) {
            console.error('Google Redirect URI not configured');
            return;
        }
        
        // Store the current URL to return to after auth
        sessionStorage.setItem('auth_redirect', window.location.pathname + window.location.search);
        
        // Construct Google OAuth URL
        const googleAuthUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
        const params = {
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: 'email profile',
            prompt: 'select_account',
            access_type: 'offline',
            state: btoa(JSON.stringify({ 
                nonce: Math.random().toString(36).substring(2),
                redirect: sessionStorage.getItem('auth_redirect')
            }))
        };
        
        // Add parameters to URL
        Object.keys(params).forEach(key => 
            googleAuthUrl.searchParams.append(key, params[key])
        );
        
        // Redirect to Google sign-in
        window.location.href = googleAuthUrl.toString();
    };

    return (
        <button
            onClick={handleGoogleSignIn}
            type="button"
            className="w-full relative flex items-center px-4 py-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
            <div className="absolute left-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                </svg>
            </div>
            <span className="mx-auto text-base">Continue with Google</span>
        </button>
    );
};

export default GoogleSignInButton;
